var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-progress"},[_c('progress',{attrs:{"max":_vm.steps.length},domProps:{"value":_vm.currentStep}}),_c('div',{staticClass:"wizard-progress__steps"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:[
        'wizard-progress__step',
        index + 1 === _vm.currentStep ? 'active' : ''
      ]},[_c('SvgIcon',{attrs:{"name":_vm.getStepIcon(index)}}),_c('span',[_vm._v(_vm._s(step.title))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }